var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"container"},[_c('AppCard',{staticClass:"is-big",attrs:{"appIcon":"Gitimoji512@2x","routerLink":"/gitimoji"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }